const cards = [
  {
    id: 1,
    title: '本周热门：国产悬疑片《迷雾追踪》口碑爆棚',
    desc: '紧张刺激的剧情设计，层层递进的悬疑氛围，这部91精品视频在线播放的热门影片上线三天即突破百万播放量。',
    date: '2026-07-30',
    tag: '影视资讯',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20thriller%20film%20scene%20with%20foggy%20urban%20alleyway%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20dramatic%20cinematic%20lighting%20with%20deep%20shadows%2C%20film%20noir%20aesthetic%2C%20high%20contrast%20photography%2C%20suspenseful%20atmosphere%2C%20professional%20cinematography&width=600&height=400&seq=card-img-01&orientation=landscape',
  },
  {
    id: 2,
    title: '91免费视频网站年度十大高分国产片盘点',
    desc: '综合网友评分与播放数据，我们整理出今年最值得一看的十部国产影片，涵盖剧情、爱情、动作等多种类型。',
    date: '2026-07-29',
    tag: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20golden%20film%20award%20trophies%20arranged%20on%20a%20dark%20velvet%20surface%20with%20dramatic%20spotlight%20illumination%2C%20warm%20golden%20and%20deep%20red%20color%20scheme%2C%20cinematic%20award%20ceremony%20aesthetic%2C%20professional%20product%20photography%2C%20elegant%20composition&width=600&height=400&seq=card-img-02&orientation=landscape',
  },
  {
    id: 3,
    title: '91麻豆免费视频网站推出经典老片修复专区',
    desc: '为满足影迷对经典国产影片的观影需求，平台全新上线经典老片修复专区，91在线观看免费重温那些年我们追过的电影。',
    date: '2026-07-28',
    tag: '平台动态',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20film%20posters%20displayed%20on%20a%20brick%20wall%20with%20warm%20nostalgic%20lighting%2C%20old%20movie%20memorabilia%2C%20film%20reels%20and%20projector%20in%20foreground%2C%20retro%20cinema%20aesthetic%2C%20sepia%20and%20golden%20tones%2C%20artistic%20arrangement&width=600&height=400&seq=card-img-03&orientation=landscape',
  },
  {
    id: 4,
    title: '暑期档国产动作片合集，高燃对决不容错过',
    desc: '暑期档多部国产动作片在91免费在线视频平台集中上线，精彩打斗场面、震撼视觉特效，带给你105分钟不间断的视听盛宴。',
    date: '2026-07-27',
    tag: '影视资讯',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20martial%20arts%20action%20film%20scene%20with%20two%20fighters%20in%20silhouette%20against%20a%20fiery%20sunset%20sky%2C%20dramatic%20dust%20and%20sparks%2C%20wide%20cinematic%20shot%2C%20high%20contrast%20action%20photography%2C%20professional%20film%20still%20with%20motion%20blur&width=600&height=400&seq=card-img-04&orientation=landscape',
  },
  {
    id: 5,
    title: '如何找到高质量的91精品视频在线播放资源',
    desc: '从片源筛选到画质对比，我们为你总结了一套实用的选片指南，帮你在海量91免费看视频资源中快速找到心仪影片。',
    date: '2026-07-26',
    tag: '观影指南',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20imagery%2C%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20movie%20night%20atmosphere%2C%20professional%20interior%20photography%2C%20golden%20and%20warm%20tones&width=600&height=400&seq=card-img-05&orientation=landscape',
  },
  {
    id: 6,
    title: '91福利在线视频每日更新预告（7月31日）',
    desc: '今日上线6部全新国产影片，包括3部剧情片、2部爱情片和1部纪录片。91在线免费播放专区同步更新，欢迎准时观看。',
    date: '2026-07-31',
    tag: '每日预告',
    image: 'https://readdy.ai/api/search-image?query=Digital%20calendar%20with%20film%20strip%20design%20elements%2C%20movie%20clapperboard%20and%20countdown%20timer%2C%20warm%20cinematic%20lighting%20with%20red%20and%20gold%20accents%2C%20modern%20flat%20lay%20aesthetic%2C%20professional%20content%20creator%20photography%2C%20clean%20composition&width=600&height=400&seq=card-img-06&orientation=landscape',
  },
  {
    id: 7,
    title: '影迷社区：聊聊你心中的国产影片TOP 3',
    desc: '91免费视频网站影迷社区发起讨论活动，分享你最爱的三部国产影片及推荐理由，参与即有机会获得观影权益奖励。',
    date: '2026-07-25',
    tag: '社区互动',
    image: 'https://readdy.ai/api/search-image?query=Group%20of%20film%20enthusiasts%20discussing%20movies%20in%20a%20cozy%20cafe%20setting%2C%20warm%20ambient%20lighting%2C%20movie%20posters%20on%20wall%2C%20laptops%20and%20notebooks%20on%20table%2C%20candid%20documentary%20style%20photography%2C%20friendly%20atmosphere&width=600&height=400&seq=card-img-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="section-scroll py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">最新动态</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">影视资讯</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            及时了解91年国产影片视频的最新片单、平台资讯与观影指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <a
              key={card.id}
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-xl overflow-hidden bg-gray-50 border border-gray-100 hover:border-red-200 transition-all duration-300 hover:shadow-lg cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-gray-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    const p = t.parentElement;
                    if (p) {
                      p.classList.add('flex', 'items-center', 'justify-center', 'bg-gray-100');
                      p.innerHTML = `<div class="text-gray-400 text-sm"><i class="ri-image-line text-2xl block mb-1"></i>${card.tag}</div>`;
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-red-600/90 text-white text-xs font-semibold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-gray-900 group-hover:text-red-600 transition-colors line-clamp-2 mb-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-500 leading-relaxed line-clamp-3 mb-3">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400 flex items-center gap-1">
                    <i className="ri-calendar-line"></i>{card.date}
                  </span>
                  <span className="text-xs text-red-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    阅读更多 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}